/*
Ashraf 01/31/2023 2699714747 Added sort fields table
*/

import { Button, Grid, TablePagination } from '@material-ui/core';
// import MaterialTable from "material-table";
import React, { createRef, useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tableIcons } from '../../../../../../components/TableIcons';
import { defaultRows } from '../../../../../../constants/ReusableTablePagination';
import {
  fetchDataRepository,
  printDataRepositories,
  resetDataRepo,
  fetchDataRepoUsage,
} from '../../../../../../redux/reducers/GlobalField/DataRepository';
import { httpPaginationDelete } from '../../../../../../util/Rest';
import { resetMessage } from '../../../../../../redux/reducers/GlobalField/AddFieldList';
import { resetMsg } from '../../../../../../redux/reducers/GlobalField/DataRepository';
import {
  SuccessSnackbar,
  ErrorSnackbar,
  WarningSnackbar,
} from '../../../../../../components/CustomSnackBar';
import { postPrintUsage, resetPrintUsageData } from '../../../../../../redux/reducers/printUsage';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import { useUpdateEffect } from 'react-use';
import OverrideRule from '../../../../../../components/OverrideRule';
import SelectTabContextProvider from '../../../../../../components/SelectTabContext/SelectTabContext';
import { makeStyles } from '@material-ui/core';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import { tablePageRows } from '../../../../../../constants/ReusableConstants';
import UsageMessage from '../../../../../../util/UsageMessage';
import moment from 'moment';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
// import DataRepositorySystemNotes from "../AddDataRepositories/DataRepositorySystemNotes";
import { DATA_REPOSITORY } from '../../../../../../constants/ReusableRoleAccess';
import reusableInputStyles from '../../../../../../components/InputStyles';

const FieldListSearchTable = ({
  setAllSortFields,
  allSortFields,
  eventTrigger,
  searchData,
  setTabValue,
  submit,
  setSubmit,
  setFieldListRowData,
  setUsage,
  usage,
  isDelete,
  setIsDelete,
  userMetrixDelete,
  setUsageState,
  usageState,
  setRowSelected,
  setUserMetrixDelete,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  setFieldList,
  fieldList,
  isReportLoader,
  deleteSql,
  isReports,
  isReportsFilter,
  rules = [],
  sortFields = [],
  setSortFields,
  selectedRows = [],
  setFieldValue,
  setSelectedRows,
  isGlobalFieldList,
  resultExpCondition,
  reportFieldsDeleteIdsRef,
  sortFieldsDeleteIdsRef,
  resultRef,
  linkedCategory,
  values,
  fieldsDeleteIdsRef,
  tempSelectedRows = [],
  setTempSelectedRows,
  tempUnCheckedRef,
  addAccountUpdate,
  setSelectedGlobalField,
  handleEventTacticSearch,
  mapFields,
  workQueue,
  setFormulaFields,
  formulaFields,
  setFilterFields,
  filterFields,
  isDataManager,
  dmValues,
  isDMRTrue,
  setIntermediateField,
  intermediateField,
  handleSelectTriggerField,
  saveData,
  setSaveData,
  selectedRepoField,
  setSelectedField,
  isFormulaTrue,
  isDMTrue,
}) => {
  const classes = reusableInputStyles();
  const tableRef = createRef();
  const dispatch = useDispatch();
  const maxSelections = 1;
  const handleSelectionProps = (rowData) => {
    return {
      disabled:
        (eventTrigger &&
          saveData &&
          saveData?.length >= maxSelections &&
          !rowData.tableData.checked) ||
        (setIntermediateField &&
          tempSelectedRows?.length >= maxSelections &&
          !rowData.tableData.checked),
    };
  };
  const [rows, setRows] = useState(defaultRows);
  // const [deleteData, setDeleteData] = useState({});
  const deleteData = {};
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  // const [dataCount, setDataCount] = useState('');
  const dataCount = '';
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const { setGlobalFieldRow } = useContext(SelectTabContextProvider);

  const printusage = useSelector(({ printusage }) => printusage);
  const { roleData } = useSelector(({ role }) => role);
  const dataRepoAccess = roleData?.window?.[DATA_REPOSITORY]?.['RF'];
  // const [order, setOrder] = useState({});
  const order = {};
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);

  const { DataRepoPrintStatus, successMsg, errorMsg, isLoading, dataRepoUsage } = useSelector(
    ({ dataRepository }) => dataRepository,
  );

  const useStyles = makeStyles((theme) => ({
    link: {
      // Changed field list code column font color (2700799562)
      color: '#320469 !important',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();
  useEffect(() => {
    if (setTempSelectedRows) {
      if (intermediateField && 'fieldName' in intermediateField) {
        setTempSelectedRows([intermediateField]);
      } else {
        setTempSelectedRows([]);
      }
      tempUnCheckedRef.current = [];
    }
  }, []);
  useEffect(() => {
    if (dataRepoUsage?.userMetrix === 'No') {
      deleteUsage ? setUserMetrixDelete(false) : setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
        dispatch(resetDataRepo());
      }, 3000);
    } else if (dataRepoUsage?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !deleteUsage && setUsage(true);
      !deleteUsage && setTabValue(2);
    }
  }, [dataRepoUsage]);

  useEffect(() => {
    if (DataRepoPrintStatus === 200 && successMsg) {
      setTimeout(() => {
        dispatch(resetDataRepo());
        setTabValue(0);
      }, 3000);
    }
  }, [DataRepoPrintStatus, successMsg]);

  useEffect(() => {
    // if (tableRef?.current && submit) {
    //     Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : "";
    // }
  }, [submit]);

  // if table data print successfully or error message then reset message after 3sec.(2700799562)
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);

  // delete data reset error or sucess toast message after 2.5sec(2700799562)
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);

  // if Usage then reset Usage State(2700799562)
  useEffect(() => {
    usageState && setUsageState(false);
    setUsage(false);
  }, []);

  const handleCloseDialog = () => {
    setIsDelete(false);
    setTimeout(() => {
      setUserMetrixDelete(false);
    }, 1000);
  };

  // status is changed Update Table Data(2700799562)
  useUpdateEffect(() => {
    // if (status === true) {
    //     tableRef.current.onQueryChange();
    //     setStatus(false);
    // }
  }, [status]);

  // delete Global Field List(2700799562)
  const handleSubmit = () => {
    setStatus(true);
    httpPaginationDelete(`data-repository/delete/data-repository/${deleteData?.dataRepositoryId}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setStatus(false);
          // dispatch(fetchSuccess(response));
          handleCloseDialog();
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setStatus(false);
          handleCloseDialog();
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // checking when delete there is usage or not(2700799562)
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      // setFieldListRowData(deleteData);
      setUsage(true);
      setIsDelete(false);
      setTimeout(() => {
        setUserMetrixDelete(false);
      }, 1000);

      // setTabValue(2);
    } else {
      handleSubmit();
    }
  };
  const columns = [
    // {
    //     title: "Category",
    //     field: "category",
    //     maxWidth: "80px",
    //     render: (rowData) => {
    //         return rowData?.category === "C"
    //             ? "C - Client"
    //             : rowData?.category === "D"
    //                 ? "D - Debtor"
    //                 : rowData?.category === "P"
    //                     ? "P - Payment"
    //                     : "";
    //     },
    // },
    // {
    //     title: "Repository Type",
    //     field: "repositoryType",
    //     maxWidth: "120px",
    //     render: (rowData) => {
    //         return rowData?.repositoryType?.toUpperCase() === "SYSTEM"
    //             ? "S - SYSTEM"
    //             : rowData?.repositoryType?.toUpperCase() === "USER"
    //                 ? "U - USER"
    //                 : "";
    //     },
    // },
    {
      title: 'Repository Name',
      field: 'repositoryName',
      maxWidth: 165,
      render: (rowData) =>
        isReports ? (
          <div className="table-word-wrap">{rowData?.repositoryName}</div>
        ) : (
          <span
            role="button"
            className={`table-word-wrap-border ${classes1.link}`}
            onClick={() => {
              if (rowData?.dataRepositoryId) {
                dispatch(fetchDataRepository(rowData?.dataRepositoryId));
                setRowSelected && setRowSelected(rowData?.dataRepositoryId);
                if (!StepperFieldList) {
                  setTabValue(1);
                  setGlobalFieldRow(true);
                } else {
                  setShowSearch && setShowSearch(true);
                }
              }
              handleSelectTriggerField && handleSelectTriggerField(rowData);
            }}
          >
            {rowData?.repositoryName}
          </span>
        ),
    },
    {
      title: 'Field Name',
      field: 'fieldName',
      maxWidth: 165,
      render: (rowData) => (
        <>
          <div className="table-word-wrap">{rowData?.fieldName} </div>
        </>
      ),
    },
    {
      title: 'Field Type',
      field: 'fieldType',
      maxWidth: '85px',
      hidden: !isReports,
    },
    // {
    //     title: "Data Type",
    //     field: "dataType",
    // },
    // {
    //     title: "Created By",
    //     field: "createdBy",
    //     maxWidth: 100,
    // },
    // {
    //     title: "Created Date",
    //     field: "createdDate",
    //     maxWidth: 90,
    //     render: (rowData) => {
    //         return rowData?.createdDate ? moment(rowData?.createdDate).format("MM/DD/YYYY") : "";
    //     },
    // },
  ];
  const SearchSessionRepository = JSON.parse(sessionStorage.getItem('Repository'));
  if (SearchSessionRepository && !submit && !mapFields) {
    searchData = SearchSessionRepository;
  }
  return (
    <>
      {isLoading || (
        <DeleteTableRecordPopup
          open={isDelete}
          dialogClose={handleCloseDialog}
          title="Delete Data Repository"
          value={
            userMetrixDelete ? (
              <UsageMessage value={'Data Repository'} />
            ) : (
              `Are you sure want to delete this ${deleteData?.repositoryName} Data Repository ?`
            )
          }
          handleSubmit={handleDeleteUsage}
          buttonCondition={userMetrixDelete}
        />
      )}
      <OverrideRule
        dialogTitle="Data Repository Usage"
        dialogOpen={usage}
        dialogClose={() => setUsage((state) => !state)}
        title={`This Data Repository has been used in the following places.`}
        data={dataRepoUsage?.placeResponse}
        type={'Data Repository'}
        isOverRide={false}
      />
      <Grid item xs={12}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon new-standard-textfields  global-field-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              eventTrigger && setSaveData && setSaveData(rows);
              if (row?.tableData?.checked) {
                // if ((setFormulaFields && formulaFields) || setIntermediateField) {
                //     if (tempSelectedRows) {
                //         const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                //         arr.push({
                //             ...row,
                //             tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                //         });
                //         setTempSelectedRows(arr);
                //     }
                // }
                // if (setFilterFields && filterFields) {
                //     if (tempSelectedRows) {
                //         const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                //         arr.push({
                //             ...row,
                //             tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                //         });
                //         setTempSelectedRows(arr);
                //     }
                // }
                // if (setSelectedRows && selectedRows) {
                //     if (tempSelectedRows) {
                //         const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                //         arr.push({
                //             ...row,
                //             tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                //             ...(!isReportsFilter && getFields(row)),
                //             processorFieldType: "DB Field",
                //             dataType: row.fieldType,
                //         });
                //         console.log(arr, "tempArr");
                //         setTempSelectedRows(arr);
                //     }
                // }
                // if (isDMRTrue) {
                //     if (tempSelectedRows) {
                //         const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                //         arr.push({
                //             ...row,
                //             tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                //             processorFieldType: "DB Field",
                //             dataType: row.fieldType,
                //         });
                //         setTempSelectedRows(arr);
                //     }
                // }
                // if (isDataManager) {
                //     if (tempSelectedRows) {
                //         const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                //         arr.push({
                //             ...row,
                //             tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                //             mapFieldType: "DB Field",
                //             fieldHeader: row.fieldName,
                //             fieldPosition: "",
                //             startPosition: "",
                //             fieldLength: "",
                //             format: "",
                //             dataType: row.fieldType,
                //         });
                //         setTempSelectedRows(arr);
                //     }
                // }
                // if (rules && isReportsFilter) {
                //     if (row?.tableData?.checked) {
                //         const arr = [...tempSelectedRows];
                //         arr.push({
                //             ...row,
                //             tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                //         });
                //         setTempSelectedRows(arr);
                //     }
                // }
                if (setSortFields && tempSelectedRows) {
                  const dataObj = {
                    seqNum: '',
                    sortOrder: 'N',
                    printTotal: 'N',
                  };
                  setTempSelectedRows([
                    ...tempSelectedRows,
                    {
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                      ...dataObj,
                    },
                  ]);
                }
              } else {
                // if ((setSelectedRows && setTempSelectedRows) || setIntermediateField) {
                //     tempUnCheckedRef.current.push(row);
                //     const updatedRows = [...tempSelectedRows]
                //         .filter(
                //             (ele) =>
                //                 ele?.fieldName + ele?.repositoryName !==
                //                 row?.fieldName + row?.repositoryName
                //         )
                //         .map((ele) => {
                //             return {
                //                 ...ele,
                //                 tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                //             };
                //         });
                //     setTempSelectedRows(updatedRows);
                // }
                // if (isDataManager) {
                //     tempUnCheckedRef.current.push(row);
                //     const updatedRows = [...tempSelectedRows]
                //         .filter(
                //             (ele) =>
                //                 ele?.fieldName + ele?.repositoryName !==
                //                 row?.fieldName + row?.repositoryName
                //         )
                //         .map((ele) => {
                //             return {
                //                 ...ele,
                //                 tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                //             };
                //         });
                //     setTempSelectedRows(updatedRows);
                // }
                // if (isDMRTrue) {
                //     tempUnCheckedRef.current.push(row);
                //     const updatedRows = [...tempSelectedRows]
                //         .filter(
                //             (ele) =>
                //                 ele?.fieldName + ele?.repositoryName !==
                //                 row?.fieldName + row?.repositoryName
                //         )
                //         .map((ele) => {
                //             return {
                //                 ...ele,
                //                 tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                //             };
                //         });
                //     setTempSelectedRows(updatedRows);
                // }
                // if (setFormulaFields && formulaFields) {
                //     tempUnCheckedRef.current.push(row);
                //     const updatedRows = [...tempSelectedRows]
                //         .filter(
                //             (ele) =>
                //                 ele?.fieldName + ele?.repositoryName !==
                //                 row?.fieldName + row?.repositoryName
                //         )
                //         .map((ele) => {
                //             return {
                //                 ...ele,
                //                 tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                //             };
                //         });
                //     setTempSelectedRows(updatedRows);
                // }
                // if (setFilterFields && filterFields) {
                //     tempUnCheckedRef.current.push(row);
                //     const updatedRows = [...tempSelectedRows]
                //         .filter(
                //             (ele) =>
                //                 ele?.fieldName + ele?.repositoryName !==
                //                 row?.fieldName + row?.repositoryName
                //         )
                //         .map((ele) => {
                //             return {
                //                 ...ele,
                //                 tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                //             };
                //         });
                //     setTempSelectedRows(updatedRows);
                // }

                if (setSortFields) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele.repositoryName !== row?.fieldName + row.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                // if (rules && isReportsFilter) {
                //     const updatedRows = [...tempSelectedRows]
                //         .filter(
                //             (ele) =>
                //                 ele?.fieldName + ele.repositoryName !== row?.fieldName + row.repositoryName
                //         )
                //         .map((ele) => {
                //             return {
                //                 ...ele,
                //                 tableData: { ...ele.tableData, id: ele.fieldName + ele.repositoryName },
                //             };
                //         });
                //     setTempSelectedRows(updatedRows);
                // }
              }
            }}
            isLoading={isLoading || isReportLoader || printusage?.isLoading}
            data={allSortFields}
            actions={
              !isReports
                ? [
                  {
                    icon: () => (
                      <>
                        <Button
                          type="button"
                          variant="outlined"
                          className={`mx-1 search-btn`}
                          disabled={!dataRepoAccess?.add}
                        >
                            Add Data Repository
                        </Button>
                      </>
                    ),
                    isFreeAction: true,
                    disabled: !dataRepoAccess?.add,
                    onClick: (event) => {
                      dispatch(resetMsg());
                      if (StepperFieldList) {
                        setShowSearch(true);
                      } else {
                        setTabValue(1);
                      }
                    },
                  },
                  (rowData) => ({
                    icon: () => <EditOutlinedIcon />,
                    tooltip: 'Edit',
                    disabled: rowData?.repositoryType === 'SYSTEM' || !dataRepoAccess?.edit,
                    onClick: (event, rowData) => {
                      if (rowData?.dataRepositoryId) {
                        dispatch(fetchDataRepository(rowData?.dataRepositoryId));
                        setRowSelected(rowData?.dataRepositoryId);
                        if (!StepperFieldList) {
                          setTabValue(1);
                          setGlobalFieldRow(true);
                        } else {
                          setShowSearch(true);
                        }
                      }
                    },
                  }),
                  // (rowData) => ({
                  //   icon: () => <FileCopyOutlinedIcon />,
                  //   tooltip: "Copy",
                  //   disabled: true,
                  //   hidden: rowData?.repositoryType === "SYSTEM",
                  //   onClick: (event, rowData) => {
                  //     setIsCopyData(true);
                  //     dispatch(fetchDataRepository(rowData?.dataRepositoryId));
                  //     setTabValue(1);
                  //   },
                  // }),
                  (rowData) => ({
                    icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
                    tooltip: 'Usage',
                    hidden: isReports,
                    onClick: (event, rowData) => {
                      setDeleteUsage(false);
                      dispatch(fetchDataRepoUsage(rowData, 'RepoField'));
                      setFieldListRowData(rowData);
                    },
                  }),
                  {
                    icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
                    tooltip: 'Data Repository Notes',
                    // hidden: reportMasterSearch,
                    // onClick: (event, rowData) => {
                    //   setIsNote(true);
                    // },
                  },
                ]
                : []
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: !isReports,
              toolbarButtonAlignment: 'left',
              selection: isReports && !addAccountUpdate,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              showTextRowsSelected: false,
              selectionProps:
                eventTrigger || setIntermediateField
                  ? handleSelectionProps
                  : (rowData) => {
                    let disabledFields = false;
                    if (isDataManager) {
                      dmValues?.selectedFields?.forEach((el) => {
                        if (
                          el.repositoryName.concat(el.fieldName) ===
                              rowData.repositoryName.concat(rowData.fieldName) &&
                            (el.isEditable === false || el?.mapFieldType === 'Audit Field')
                        ) {
                          disabledFields = true;
                        }
                      });
                    }
                    if (isDMRTrue) {
                      dmValues?.selectedFields?.forEach((el) => {
                        if (
                          el.repositoryName?.concat(el.fieldName) ===
                              rowData.repositoryName?.concat(rowData.fieldName) &&
                            (el.tabType === 'Record Format Field' ||
                              el?.isEditable === false ||
                              el?.processorFieldType === 'Audit Field')
                        ) {
                          disabledFields = true;
                        }
                      });
                    }
                    if (isDMTrue) {
                      selectedRows?.forEach((el) => {
                        if (
                          el.repositoryName?.concat(el.fieldName) ===
                              rowData.repositoryName?.concat(rowData.fieldName) &&
                            (el.type === 'Record' ||
                              el?.isEditable === false ||
                              el.type === 'Record Group')
                        ) {
                          disabledFields = true;
                        }
                      });
                    }
                    const checked = rowData?.active === 'no' ? { checked: false } : {};
                    const selectedCategories = selectedRows?.map((each) => each?.category);
                    const disableCheckedFieldListC = selectedCategories?.includes('CL')
                      ? rowData.fieldName === 'CLIENT_NUMBER' &&
                          rowData.repositoryName === 'DB_ACCOUNT'
                        ? true
                        : false
                      : false;
                    const disableCheckedFieldListD = selectedCategories?.includes('CO')
                      ? rowData.fieldName === 'ACCOUNT_NUMBER' &&
                          rowData.repositoryName === 'DB_ACCOUNT'
                        ? true
                        : false
                      : false;
                    return {
                      disabled:
                          rowData?.active === 'no' || workQueue
                            ? rowData?.fieldName === 'ACCOUNT_NUMBER' &&
                              rowData?.repositoryName === 'DB_ACCOUNT'
                            : isGlobalFieldList
                              ? disableCheckedFieldListC || disableCheckedFieldListD
                              : isDataManager || isDMRTrue || isDMTrue
                                ? disabledFields
                                : false,
                      ...checked,
                    };
                  },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                // Added Download Configuration Buttons in Table Pagination (2700799562)
                <div className="global-field-table-footer ">
                  {/* letter we removed that one */}
                  {isReports && <div className="mt-2"></div>}
                  {!isReports && (
                    <div className="mt-2">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(dataCount === 0)}
                        onClick={(event) => {
                          dispatch(
                            postPrintUsage({
                              category: searchData?.category?.categoryCode
                                ? searchData.category?.categoryCode
                                : '',
                              fieldListOrderBy: '',
                              fieldListOrderDerection: '',
                              createdBy: searchData?.createdBy?.userName
                                ? searchData?.createdBy?.userName
                                : '',
                              createdDate: searchData?.createdDate
                                ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                                : '',
                              fieldName: searchData?.fieldName ? searchData.fieldName : '',
                              frameworkUsageOrderBy: order?.orderBy ? order?.orderBy : '',
                              frameworkUsageOrderDerection: order?.orderDirection
                                ? order?.orderDirection
                                : '',
                              repositoryName: searchData?.repoName ? searchData.repoName : '',
                              repositoryDescription: searchData?.repoDescription
                                ? searchData.repoDescription
                                : '',
                              repositoryType: searchData?.repoType?.repoTypeName
                                ? searchData?.repoType?.repoTypeName
                                : '',
                              sourceType: 'DATA REPOSITORY',
                            }),
                          );
                        }}
                      >
                        Download Configuration Usage
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(dataCount === 0)}
                        onClick={(event) => {
                          dispatch(
                            printDataRepositories({
                              category: searchData?.category?.categoryCode
                                ? searchData.category?.categoryCode
                                : '',
                              fieldName: searchData?.fieldName ? searchData.fieldName : '',
                              repositoryName: searchData?.repoName ? searchData.repoName : '',
                              repositoryDescription: searchData?.repoDescription
                                ? searchData.repoDescription
                                : '',
                              repositoryType: searchData?.repoType?.repoTypeName
                                ? searchData?.repoType?.repoTypeName
                                : '',
                              orderBy: order?.orderBy ? order?.orderBy : '',
                              orderDirection: order?.orderDirection ? order?.orderDirection : '',
                              createdBy: searchData?.createdBy?.userName
                                ? searchData?.createdBy?.userName
                                : '',
                              createdDate: searchData?.createdDate
                                ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                                : '',
                            }),
                          );
                        }}
                      >
                        Download Configuration
                      </Button>
                    </div>
                  )}
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: { 'aria-label': 'Rows per screen' },
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
            onRowClick={(event, rowData) => {
              if (addAccountUpdate) {
                setSelectedGlobalField(rowData);
                handleEventTacticSearch(false);
              }
            }}
          />
        </div>
        {customError && (
          <WarningSnackbar errorMsg={'This Data Repository is not being used anywhere'} />
        )}
        {(errorMsg || deleteErrorMsg || printusage?.errorMsg) && (
          <ErrorSnackbar errorMsg={errorMsg || printusage?.errorMsg || deleteErrorMsg} />
        )}
        {(successMsg || printusage?.successMsg || tstmsg) && (
          <SuccessSnackbar successMsg={successMsg || printusage?.successMsg || tstmsg} />
        )}
      </Grid>
    </>
  );
};

export default React.memo(FieldListSearchTable);
